import { Component } from '@angular/core';
import { AlertService } from './core/services/alert.service';
import { loadCldr,L10n } from '@syncfusion/ej2-base';
declare var require: any;

loadCldr(
  require('cldr-data/main/de/numbers.json'),
  require('cldr-data/main/de/currencies.json'),
  require('cldr-data/supplemental/numberingSystems.json'),
  require('cldr-data/supplemental/currencyData.json')
);

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title = 'industriepartner-frontend';

    constructor() {
      L10n.load({
        'de': {
          'numerictextbox': {
            incrementTitle: 'Wert erhöhen', decrementTitle: 'Dekrementwert'
          }
        }
      });
    }
}
